import React from 'react';
import placeholderLogo from '../media/placeholder.svg';

const ResponsiveImage = ({ src, alt }) => {
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img
                src={src || placeholderLogo} // Use provided src or fallback to placeholder
                alt={alt}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                loading="lazy" // Keep lazy loading for performance
            />
        </div>
    );
};

export default ResponsiveImage;